import React from "react";
import CardProjectFiche from "./CardProjectFiche";
import { typeForDetailsProyect } from "../../../../types/typeModalDetailsProject";
import { iconsDetailsProyect } from "../../../../assets/icons/detailsProject";
import { ContainerInformationProjectDetails } from "../../../../components/container/ContainerInformationProjectDetails";


const getCategoriesView = (categories = []) => {
    return categories.map(({ name, subCategories }) => {
        return `${name}: [${subCategories.join(",")}] - `;
    });
};

const getPlatformsView = (platforms = []) => {
    return platforms.reduce((prev, { name }) => prev + name + " - ", "");
};

const CardProyectInfo = ({ isSuperAdmin, isAdmin, projectDetails, activeModalDetailsProject }) => {
    return (
        <CardProjectFiche
            title="Proyecto"
            enableButtonExtra={isSuperAdmin || isAdmin}
            buttonExtra={
                <>
                    <div
                        onClick={() => {
                            activeModalDetailsProject(typeForDetailsProyect.projects);
                        }}
                        className="h-full w-[15px] cursor-pointer"
                    >
                        <img className="h-full w-full object-contain" src={iconsDetailsProyect.editbutton} alt="edit" />
                    </div>
                </>
            }
            className="h-full"
        >
            <div className="h-full overflow-hidden">
                <ContainerInformationProjectDetails className="h-[48px]" name="Nombre del Proyecto:">
                    <div className=" bg-[#EFF2F5] rounded-[4px] pl-2 w-full h-full flex items-center">
                        <span className="text-[10px]">{projectDetails.name}</span>
                    </div>
                </ContainerInformationProjectDetails>
                <div className="w-full h-[48px] flex gap-2">
                    <ContainerInformationProjectDetails className="h-full w-[120px]" name="Semanas de desarrollo">
                        <div className=" bg-[#EFF2F5] rounded-[4px] pl-2 w-full h-full flex items-center">
                            <span className="text-[10px]">{projectDetails.dates.weeks}</span>
                        </div>
                    </ContainerInformationProjectDetails>
                    <ContainerInformationProjectDetails className="h-full w-[calc(100%-120px)]" name="Estado">
                        <div className=" bg-[#EFF2F5] rounded-[4px] pl-2 w-full h-full flex items-center">
                            <span className="text-[10px]">{projectDetails.status}</span>
                        </div>
                    </ContainerInformationProjectDetails>
                </div>
                <ContainerInformationProjectDetails className="h-[48px]" name="Categoría">
                    <div className=" bg-[#EFF2F5] rounded-[4px] pl-2 w-full h-full flex items-center overflow-auto">
                        <span className="text-[10px]">{getCategoriesView(projectDetails.categories)}</span>
                    </div>
                </ContainerInformationProjectDetails>
                <ContainerInformationProjectDetails className="h-[48px]" name="Plataformas">
                    <div className=" bg-[#EFF2F5] rounded-[4px] pl-2 w-full h-full flex items-center  overflow-auto">
                        <span className="text-[10px]">{getPlatformsView(projectDetails.platforms)}</span>
                    </div>
                </ContainerInformationProjectDetails>
                <ContainerInformationProjectDetails className="h-[240px] md:h-[480px] xl:h-[450px]" name="Descripción">
                    <div className=" bg-[#EFF2F5] rounded-[4px] pl-2 w-full h-full flex py-2 overflow-auto">
                        <span className="text-[10px]">{projectDetails.description}</span>
                    </div>
                </ContainerInformationProjectDetails>
                <ContainerInformationProjectDetails className="h-[48px]" name="Propiedades">
                    <div className=" bg-[#EFF2F5] rounded-[4px] pl-2 w-full h-full flex items-center">
                        <span className="text-[10px]">{projectDetails.propertiesCard.join(",")}</span>
                    </div>
                </ContainerInformationProjectDetails>
            </div>
        </CardProjectFiche>
    );
};


export default CardProyectInfo